import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { ParticipantDetailsDto } from '@/features/dashboard/participants/types/ParticipantDetailsDto.ts';
import { ParticipantListDto } from '@/features/dashboard/participants/types/ParticipantListDto.ts';

const participantsApi = {
  getTableDefinition: async (): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `participants/table-definition`,
    );
  },
  getParticipants: async (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<ParticipantListDto>> => {
    const params = buildPageRequestParams(pageRequest);

    return await fetchPrivateApi<PagedDto<ParticipantListDto>>(
      'POST',
      `participants/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getParticipantDetails: async (
    participantId: string,
  ): Promise<ParticipantDetailsDto> => {
    return await fetchPrivateApi<ParticipantDetailsDto>(
      'GET',
      `participants/${participantId}`,
    );
  },
};

export default participantsApi;
